import { CodeBlock } from 'react-code-blocks';
import parse, { domToReact, Element } from 'html-react-parser';

import KlaviyoFormAtom from '@klaviyo-mkt/gatsby-components/atoms/klaviyo-form';
import HubspotFormAtom from '@klaviyo-mkt/gatsby-components/atoms/hubspot-form';
import { codeTheme } from './theme';

import type { DOMNode, HTMLReactParserOptions } from 'html-react-parser';


const headingTags = [
  'h2',
];

const getTextContent = (domNode: Element) => {
  let innerText = '';

  if (domNode?.children?.length > 0) {
    domNode?.children?.forEach((child) => {
      if (child?.type === 'text') {
        innerText += child?.data;
      }
      if (child?.type === 'tag') {
        innerText += getTextContent(child);
      }
    });
  }

  return innerText;
};

export const parser = (content = '') => {
  const h2List: { id: string; name: string; }[] = [];
  let index = 0;

  const parserOptions: HTMLReactParserOptions = {
    replace: (domNode) => {
      if (domNode instanceof Element && domNode.attribs && domNode.attribs['data-replace-kform']) {
        return (<KlaviyoFormAtom formId={domNode.attribs['data-form-id']} />);
      }
      if (domNode instanceof Element && domNode.attribs && domNode.attribs['data-replace-hubspot-form']) {
        return (<HubspotFormAtom hubspotHeaderText={domNode.attribs['data-header-text']} hubspotSubheaderText={domNode.attribs['data-subheader-text']} redirectUrl={domNode.attribs['data-redirect-url']} formId={domNode.attribs['data-form-id']} />);
      }
      if (domNode instanceof Element && domNode.tagName === 'code' && (domNode?.firstChild as unknown as HTMLElement)?.nodeValue) {
        // custom themes are technically not supported
        // if this starts misbehaving, check the theme first
        return (
          <CodeBlock
            text={(domNode.firstChild as unknown as HTMLElement).nodeValue ?? ''}
            language={domNode?.attribs?.lang}
            showLineNumbers={domNode?.attribs?.class?.includes('line-numbers')}
            theme={codeTheme}
          />
        );
      }
      if (domNode instanceof Element && (headingTags.includes(domNode.tagName))) {
        const text = getTextContent(domNode);
        const id = domNode.attribs.id || `${text.toLowerCase().replace(/[^\p{Letter}\p{Mark}]/gu, '-').replace(/^[^\p{Letter}\p{Mark}]+/gu, '')}${index}`;
        const className = domNode.attribs.class || undefined;
        const HeadingTag = `${domNode.tagName}` as keyof JSX.IntrinsicElements;
        if (domNode.tagName === 'h2') {
          h2List.push({
            id,
            name: text,
          });
        }
        index += 1;
        return (
          <HeadingTag className={className} id={id}>
            {domNode instanceof Element ? domToReact((domNode as Element)?.children as DOMNode[]) : undefined}
          </HeadingTag>
        );
      }
      if (domNode instanceof Element && domNode.tagName === 'script' && domNode.attribs.src === 'https://player.vimeo.com/api/player.js') {
        return (<></>); 
      }
      if (domNode instanceof Element && domNode.tagName === 'script' && domNode.attribs.src === 'https://platform.twitter.com/widgets.js') {
        return (<></>); 
      }
      if (domNode instanceof Element && domNode.tagName === 'script' && domNode.attribs.src === 'https://www.tiktok.com/embed.js') {
        return (<></>); 
      }
      if (domNode instanceof Element && domNode.tagName === 'iframe' && domNode.attribs.src && domNode.attribs.src.includes('youtube')) {
        domNode.attribs.loading = 'lazy';
      }
      return null;
    },
  };

  return {
    h2List,
    parsedContent: parse(content, parserOptions),
  };
};
